(function() {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('Importation', Importation);

    Importation.$inject = ['$resource', 'DateUtils'];

    function Importation ($resource, DateUtils) {
        var resourceUrl =  'api/importations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDerniereExecution = DateUtils.convertDateTimeFromServer(data.dateDerniereExecution);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
